import Box from '@material-ui/core/Box';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AppParams } from 'AppRoutes';
import { Boxes, BoxesKey } from 'home/useBoxes';
import React from 'react';
import { queryCache } from 'react-query';
import { useParams } from 'react-router-dom';
import LogTable from './LogTable';

interface Props {}

const LogDialogContent = (props: Props) => {
  const boxId = parseInt(useParams()[AppParams.LogId] ?? '-1');
  const box = queryCache
    .getQueryData<Boxes>(BoxesKey)
    ?.boxes.find((b) => b.id === boxId);

  return (
    <>
      <DialogTitle id="scroll-dialog-title">
        <Box
          display="grid"
          gridGap="10px"
          gridAutoFlow="column"
          gridTemplateColumns="auto 1fr auto 1fr"
        >
          <span>ボックス名:</span>
          <span>{box?.name}</span>
          <span>IMEI:</span>
          <span>{box?.imei}</span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <LogTable />
      </DialogContent>
    </>
  );
};

export default LogDialogContent;
